module.exports = __webpack_public_path__ + "src/assets/img/door_left.a7d30243.svg";